import script from "./locale.vue?vue&type=script&lang=ts"
export * from "./locale.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__